var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCpfAvaliador(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_179_4016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 2.66667H8C6.53333 2.66667 5.33333 3.86667 5.33333 5.33333V26.6667C5.33333 28.1333 6.53333 29.3333 8 29.3333H24C25.4667 29.3333 26.6667 28.1333 26.6667 26.6667V10.6667L18.6667 2.66667ZM16 13.3333C17.4667 13.3333 18.6667 14.5333 18.6667 16C18.6667 17.4667 17.4667 18.6667 16 18.6667C14.5333 18.6667 13.3333 17.4667 13.3333 16C13.3333 14.5333 14.5333 13.3333 16 13.3333ZM21.3333 24H10.6667V23.24C10.6667 22.16 11.3067 21.2 12.2933 20.7733C13.4267 20.28 14.68 20 16 20C17.32 20 18.5733 20.28 19.7067 20.7733C20.6933 21.2 21.3333 22.16 21.3333 23.24V24Z",
    fill: "#8D8D8D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_179_4016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpfAvaliador);
export default __webpack_public_path__ + "static/media/cpfAvaliador.3470f62b05464fde92cd9afc45d09d39.svg";
export { ForwardRef as ReactComponent };